export default __webpack_public_path__ + "static/media/KnowWho.b4f2a682.png";